import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=b57f82ce&scoped=true&"
import script from "./privacyPolicy.js?vue&type=script&lang=js&"
export * from "./privacyPolicy.js?vue&type=script&lang=js&"
import style0 from "./privacyPolicy.css?vue&type=style&index=0&id=b57f82ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57f82ce",
  null
  
)

export default component.exports